import { Controller, useFormContext } from "react-hook-form";

import { ChoiceCards } from "@/components/campos-formulario/novos/ChoiceCards";
import { FormDatePicker } from "@/components/campos-formulario/novos/FormDatePicker";
import { FormSubBlock } from "@/components/campos-formulario/form-shell/FormSubBlock";
import { ComunicadoSistemaFormData } from "@/validations/comunicado-sistema-validation-schema";
import { ComunicadoSistemaNivel } from "@/types/comunicado-sistema.type";
import { NIVEL_CHOICE_OPTIONS } from "./comunicado-choice-options";
import { SegmentacaoSection } from "./SegmentacaoSection";

/** Passo "Configuração": nível (cartões), janela de vigência e público-alvo. */
export function ConfiguracaoSection() {
  const { control, watch } = useFormContext<ComunicadoSistemaFormData>();
  // Crítico exige prazo: o aceite obrigatório não pode ser cobrado para sempre.
  const ehCritico = watch("nivel") === "CRITICO";

  return (
    <div>
      <FormSubBlock title="Nível">
        <Controller
          name="nivel"
          control={control}
          render={({ field, fieldState }) => (
            <ChoiceCards<ComunicadoSistemaNivel>
              options={NIVEL_CHOICE_OPTIONS}
              value={field.value as ComunicadoSistemaNivel}
              onChange={field.onChange}
              columns={3}
              error={fieldState.error?.message}
            />
          )}
        />
      </FormSubBlock>

      <FormSubBlock title="Vigência">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <Controller
            name="inicioEm"
            control={control}
            render={({ field, fieldState }) => (
              <FormDatePicker
                label="Início"
                helperText="A partir de quando aparece. Data futura = agendado."
                value={field.value ?? null}
                onChange={field.onChange}
                onBlur={field.onBlur}
                required
                error={fieldState.error?.message}
              />
            )}
          />
          <Controller
            name="fimEm"
            control={control}
            render={({ field, fieldState }) => (
              <FormDatePicker
                label={ehCritico ? "Fim" : "Fim (opcional)"}
                helperText={
                  ehCritico
                    ? "Obrigatório no crítico: passado o prazo ele sai do ar e quem não confirmou fica registrado nos aceites."
                    : "Deixe vazio para não ter prazo."
                }
                value={field.value ?? null}
                onChange={field.onChange}
                onBlur={field.onBlur}
                required={ehCritico}
                error={fieldState.error?.message}
              />
            )}
          />
        </div>
      </FormSubBlock>

      <SegmentacaoSection />
    </div>
  );
}
